import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import AdminPanel from "./pages/AdminPanel";
import UserPanel from "./pages/UserPanel";
import FinancialReport from "./pages/FinancialReport";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { useAuth } from "./context/AuthContext";
import Footer from "./components/layout/Footer";
import ChatBubble from "./components/ui/ChatBubble";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import RegisterPage from "./pages/RegisterPage";



export default function App() {
  const location = useLocation();
  const { currentUser } = useAuth();

  const normalizeRole = (role) => {
    const map = {
      admin: "admin",
      doctor: "doctor",
      medic: "doctor",
      assistant: "assistant",
      asistent: "assistant",
      nurse: "assistant",
      patient: "patient",
      pacient: "patient",
    };
    const normalized = map[role?.toLowerCase?.()] || role || null;
    if (!normalized) {
      return "patient";
    }
    return normalized;
  };

  const currentRole = currentUser ? normalizeRole(currentUser.role) : null;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  const getDefaultRoute = () => {
    if (!currentRole) return "/";
    if (currentRole === "admin") return "/admin";
    if (["doctor", "assistant"].includes(currentRole)) return "/user";
    if (currentRole === "patient") return "/home";
    return "/";
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-grow">
         <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />

          <Route
            path="/login"
            element={
              currentRole ? <Navigate to={getDefaultRoute()} replace /> : <LoginPage />
            }
          />

        {/* Protected routes */}

        <Route
          path="/admin"
          element={
              currentRole === "admin" ? <AdminPanel /> : <Navigate to="/home" replace />
          }
        />
        <Route
          path="/admin/report"
          element={
            currentRole === "admin" ? <FinancialReport /> : <Navigate to="/home" replace />
          }
        />

          <Route
            path="/user"
            element={
              currentRole && ["doctor", "assistant"].includes(currentRole)
                ? <UserPanel />
                : <Navigate to="/home" replace />
            }
          />

          <Route path="/home" element={<HomePage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/register" element={<RegisterPage />} />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>

      {/* ✅ Chatul sticky e aici, mereu vizibil */}
      <ChatBubble />
      {/* Footer global */}
      <Footer />
    </div>
  );
}
